import { render } from "./FooterLayout.vue?vue&type=template&id=3b1fd8f9&scoped=true"
import script from "./FooterLayout.vue?vue&type=script&lang=js"
export * from "./FooterLayout.vue?vue&type=script&lang=js"

import "./FooterLayout.vue?vue&type=style&index=0&id=3b1fd8f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1fd8f9"]])

export default __exports__